import { BaseContainerModel } from '../base-container.model';
import {bl_auth_sso_saml_init_login_RowClass} from '../../dbschema';

export class AuthSSOSamlLoginContainer extends BaseContainerModel {
    bl_auth_sso_saml_init_login: bl_auth_sso_saml_init_login_RowClass = new bl_auth_sso_saml_init_login_RowClass();
}
